import { render, staticRenderFns } from "./BaseProductSeriesConfigurations.vue?vue&type=template&id=ff800c30&scoped=true"
import script from "./BaseProductSeriesConfigurations.vue?vue&type=script&lang=js"
export * from "./BaseProductSeriesConfigurations.vue?vue&type=script&lang=js"
import style0 from "./BaseProductSeriesConfigurations.vue?vue&type=style&index=0&id=ff800c30&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff800c30",
  null
  
)

export default component.exports